import React, { useState } from 'react'
import axios from 'axios'

// Material UI
import AppBar from '@material-ui/core/AppBar'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import { Button } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Toolbar from '@material-ui/core/Toolbar'

// Style
import { makeStyles } from '@material-ui/core/styles'

// Phone Input
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'

// Alert
import { Alert, AlertTitle } from '@material-ui/lab'

// Components
import OrderConfirmation from '../OrderConfirmation/OrderConfirmation'

// Icons
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import PaymentIcon from '@material-ui/icons/Payment'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'

// Loader
import SyncLoader from "react-spinners/SyncLoader"

// Translation
import { Language } from '../../Translation'

// Redux
import { connect } from 'react-redux'

const useStyles = makeStyles((theme) => ({
    card: {
        background: "white",
        cursor: "pointer",
        marginTop: 15,
        marginBottom: 15,
        marginLeft: 15,
        marginRight: 15,
    },
    name: {
        marginBottom: 15,
    },
    pickup: {
        top: 15,
        marginBottom: 15,
    },
    footer: {
        backgroundColor: "#f5f5f5",
        position: "fixed",
        width: "100%",
        bottom: 0,
    },
    continueButton: {
        width: "100%",
        backgroundColor: "#003366",
    },
    loading: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
}));

const ReviewOrder = ({ toggleDrawer, handleSubTotal, handleTotal, storeData, clientData, cartData }) => {

    const classes = useStyles()
    const styles = { alignItems: "baseline" }

    const [orderId, setOrderId] = useState("")
    const [confirmationDrawer, setConfirmationDrawer] = useState()
    const [orderError, setOrderError] = useState("")
    const [loading, setLoading] = useState(false)
    const [blurInfo, setBlurInfo] = useState(true)

    const { store } = storeData
    const { cart } = cartData
    const { client, language } = clientData

    const toggleConfirmationDrawer = () => {
        setConfirmationDrawer(!confirmationDrawer)
    }

    const handlePlaceOrder = async () => {

        let data = {}
        let amount = handleSubTotal()
        let minimumAmount = store.MINIMUM_ORDER

        console.log(cart)

        // Cart Elements
        data.items = cart
        data.amount = amount
        data.clientKey = store.CLIENT_KEY
        data.clientInfo = client
        data.discountPercent = store.DISCOUNT_PERCENTAGE

        setOrderError("")
        setBlurInfo(true)

        if (amount <= minimumAmount) {

            // Show error to the user
            setOrderError(Language.ReviewOrderMinimumOrder[language] + minimumAmount + "$")

        } else {

            setLoading(true)
            console.log(data)

            await axios.post(process.env.REACT_APP_API_ADD_ORDER, data)
                .then((response) => {
                    console.log(response.data)

                    // Stop Loading...
                    setLoading(false)

                    // ORDER SUCCESS
                    if (response.data.Status === "Okay") {
                        setOrderId(response.data.OrderId)
                        sessionStorage.clear()
                        toggleConfirmationDrawer()
                    }

                    // ORDER FAIL
                    if (response.data.Status === "FAIL") {
                        setOrderError(response.data.Message)
                    }

                }, (error) => {

                    // Stop Loading...
                    setLoading(false)

                    // Show error to the user
                    setOrderError(error)
                    console.log(error)
                });
        }
    }

    return (
        <>
            <AppBar style={{ position: 'static', backgroundColor: "#003366" }}>
                <Toolbar>
                    <IconButton style={{ marginLeft: -20, color: "white" }} onClick={() => toggleDrawer()} color="default" aria-label="ArrowBackIcon">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6">{Language.ReviewOrderHeader[language]}</Typography>
                </Toolbar>
            </AppBar>

            <div className={classes.loading}>
                <SyncLoader
                    size={40}
                    color={"#123abc"}
                    loading={loading}
                />
            </div>

            <div style={{ marginBottom: 130 }}>
                <Card className={classes.card}>

                    <CardHeader
                        avatar={
                            <AccountBoxIcon />
                        }
                        title={Language.ReviewOrderYourInformation[language]}
                    />

                    <CardContent>

                        <TextField
                            id="name"
                            label={Language.ReviewOrderName[language]}
                            className={classes.name}
                            multiline
                            fullWidth
                            rowsMax={4}
                            value={client.name}
                            variant="outlined"
                            disabled={blurInfo}
                        />

                        <PhoneInput
                            country={'ca'}
                            onlyCountries={['ca']}
                            value={client.phone}
                            disableDropdown={true}
                            defaultErrorMessage='ERROR'
                            placeholder={'XXX-XXX-XXXX'}
                            inputStyle={{ width: '100%' }}
                            disableCountryCode={true}
                            disabled={blurInfo}
                        />
                        {client.pickup &&
                            <TextField
                                id="pickup"
                                label={Language.ReviewOrderPickupTime[language]}
                                className={classes.pickup}
                                multiline
                                fullWidth
                                rowsMax={4}
                                value={client.pickup}
                                variant="outlined"
                                disabled={blurInfo}
                            />
                        }

                    </CardContent>
                </Card>

                {/* <Card className={classes.card}>
                <CardHeader
                    avatar={
                        <ListAltIcon />
                    }
                    title="Ordering Instructions"
                />
                <CardContent>
                    <Grid>
                        <Grid item>
                            <TextField
                                id="outlined-multiline-static"
                                //value={notes}
                                label="Special Ordering Instructions"
                                style={{ width: "100%" }}
                                // onChange={event => {
                                //     const { value } = event.target;
                                //     setNotes(value)
                                // }}
                                multiline
                                rows="2"
                                placeholder="Special Instructions..."
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card> */}

                <Card className={classes.card}>
                    <CardHeader
                        avatar={
                            <PaymentIcon />
                        }
                        title={Language.ReviewOrderPayment[language]}
                    />
                    <CardContent>
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                {client.diningView === "Pickup_View"
                                    ? Language.ReviewOrderPaymentStore[language]
                                    : Language.ReviewOrderPaymentDelivery[language]
                                }
                            </Grid>
                            <Grid item>
                                <>
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={true}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                {Language.ReviewOrderPaymentCreditCard[language]}
                            </Grid>
                            <Grid item>
                                <>
                                    {Language.ReviewOrderComingSoon[language]}
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={false}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                        disabled={true}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        <Divider />
                    </CardContent>
                </Card>

                {orderError &&
                    <>
                        <Alert severity="error">
                            <AlertTitle>Error</AlertTitle>
                            <strong>{orderError}</strong>
                        </Alert>
                    </>
                }

            </div>

            <Card className={classes.footer}>
                <CardContent>
                    <Button disabled={loading} className={classes.continueButton} onClick={() => handlePlaceOrder()} variant="contained" size="large" >
                        <Typography style={{ color: "white" }}> {Language.ReviewOrderPlaceOrder[language]} {handleTotal().toFixed(2)}$</Typography>
                    </Button>
                </CardContent>
            </Card>

            <Drawer open={confirmationDrawer} anchor="right">
                <OrderConfirmation orderId={orderId} />
            </Drawer>

        </>
    )
}

const mapStateToProps = state => {
    return {
        storeData: state.storeData,
        clientData: state.clientData,
        cartData: state.cartData
    }
}

export default connect(mapStateToProps)(ReviewOrder)